import { queryCache, queryKeys } from './queryCache';

export interface ContractorTimelineResponse {
  success: boolean;
  data: {
    timeline: any[];
    escalation_events: any[];
    session?: {
      title?: string | null;
      [key: string]: unknown;
    };
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export interface ChatSessionLiveSnapshot {
  isSending: boolean;
  isThinking: boolean;
  isEscalating: boolean;
  isStreamingResponse: boolean;
  isStoppingRun: boolean;
  workStartedAt: number | null;
  activeRunStartedAt: number;
  streamingMessageId: string | null;
  streamingAccumulated: string;
  thinkingMessages: any[];
  pendingAdaptiveTrace: any[];
  queuedDraft: any | null;
  pendingTimelineItems: any[];
  awaitingServerMessageId: string | null;
}

export const getCachedTimeline = (sessionId: string): ContractorTimelineResponse | undefined =>
  queryCache.getQueryData<ContractorTimelineResponse>(queryKeys.chatTimeline(sessionId));

export const setCachedTimeline = (
  sessionId: string,
  value: ContractorTimelineResponse | ((previous?: ContractorTimelineResponse) => ContractorTimelineResponse),
) => queryCache.setQueryData(queryKeys.chatTimeline(sessionId), value);

export const getChatSessionLiveSnapshot = (sessionId: string): ChatSessionLiveSnapshot | undefined =>
  queryCache.getQueryData<ChatSessionLiveSnapshot>(queryKeys.chatLive(sessionId));

export const setChatSessionLiveSnapshot = (
  sessionId: string,
  snapshot: ChatSessionLiveSnapshot,
) => queryCache.setQueryData(queryKeys.chatLive(sessionId), snapshot);

export const clearChatSessionLiveSnapshot = (sessionId: string) =>
  queryCache.removeQueries(queryKeys.chatLive(sessionId));
